import { Box } from "@mui/material";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkButton from "../../components/atoms/TkButton";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkLabelText from "../../components/atoms/TkLabelText";
import { GlobalContext } from "../../context/globalContext";
import "./_style.scss";
import { httpAPI_COM003 } from "./api/request";
import { Controller, useForm } from "react-hook-form";
import { schema } from "./parts";
import { UserType } from "../../type/contextType/globalContextType";

/**
 * SCRR010001 退職者認証
 * @return SCRR010001 退職者認証
 */
const SCRR010001 = () => {
  // アクセスIDを取得
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const { control, handleSubmit } = useForm<any>({
    mode: "all",
    reValidateMode: "onChange",
  });

  const handleLogin = async (data: any) => {
    try {
      const res = await httpAPI_COM003({
        accessUrlId: location.state?.accessUrlId,
        authCd: data.authCd,
        userId: location.state?.userId,
        userProcessKuben: location.state?.userProcessKuben,
      });

      if (res.resultCd === "I0000") {
        const authInfo: typeof state.authInfo = {
          accessToken: res.accessToken,
          refreshToken: res.refreshToken,
          userId: res.userId,
          userType: res.userType as UserType,
          staffNo: res.staffNo,
          contractorNo: res.contractorNo,
        };

        setState({
          ...state,
          authInfo: { ...state.authInfo, ...authInfo },
          errorMsgId: "",
        });

        sessionStorage.setItem(
          "token",
          JSON.stringify({
            accessToken: res.accessToken,
            refreshToken: res.refreshToken,
          })
        );

        navigate(`/${res.screenId}`, {
          state: {
            applyId: res.applyId,
            staffNo: res.staffNo,
            businessType: res.businessType,
          },
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (e) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRR010001" data-testid="SCRR010001PageForTest">
      <Box component="form" onSubmit={handleSubmit(handleLogin)}>
        <TkInfoManual rule="\n">{labelids.labelid.LBLR010001_01}</TkInfoManual>
        <Controller
          name={"authCd"}
          control={control}
          rules={schema}
          render={({ field, formState: { errors } }) => (
            <TkLabelText
              {...field}
              className="text"
              fullWidth
              label="認証コード*"
              inputProps={{ maxLength: 6 }}
              error={!!errors.authCd}
              helperText={errors.authCd?.message as string}
            />
          )}
        />
        <TkButton fullWidth type="submit">
          ログイン
        </TkButton>
      </Box>
    </Box>
  );
};

export default SCRR010001;
